<div
  class="error-message"
  *ngIf="control?.touched && control?.hasError('required')"
>
  فیلد {{ label }} الزامی است.
</div>

<div class="error-message" *ngIf="control?.hasError('max')">
  مقدار {{ label }} نباید بیشتر از {{ control?.errors?.max?.max }} باشد.
</div>

<div class="error-message" *ngIf="control?.hasError('min')">
  مقدار {{ label }} نباید کمتر از {{ control?.errors?.min?.min }} باشد.
</div>

<div
  class="error-message"
  *ngIf="control?.touched && control?.hasError('pattern')"
>
  فرمت فیلد {{ label }} صحیح نمی‌باشد.
</div>

<div class="error-message" *ngIf="control?.hasError('maxlength')">
  طول {{ label }} نباید بیشتر از {{ control?.errors?.maxlength?.requiredLength }} کاراکتر باشد.
</div>

<!-- Backend error -->
<div class="error-message" *ngIf="control?.hasError('backend')">
  {{ control?.getError('backend') }}
</div>
